import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import React, { useContext } from "react";
import { FormContext } from "../AuditMain1";
import * as yup from "yup";
import FormikControl from '../../../../hoc/formikComponents/FormikControl.js'
import * as AiIcons from 'react-icons/ai';
import swal from '@sweetalert/with-react';

function BasicInfo1() {

  const { activeStepIndex, setActiveStepIndex, formData, setFormData,companySessionSelection,
    technicalExpertList, setTechnicalExpertList,
    leadauditorList, setLeadauditorList,
    initialValues, setInitialValues,
    mutationTechnicalExpertDetails, mutationLeadAudiorDetails, mutationAssisAuditorDetails,
    OrgList, mutationgetCompanyDetails,
    saveData, options,
    assitAuditorList, setassitAuditorList,processList
  } =
    useContext(FormContext);

  const renderError = (message) => (
    <p className="italic text-red-600">{message}</p>
  );

  const ValidationSchema = yup.object().shape({
    // name: yup.string().required(),
    // email: yup.string().email().required(),
  });
  console.log("initial values 26", companySessionSelection)
  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values) => {
          const data = { ...formData, ...values };
          saveData(values);
          setActiveStepIndex(activeStepIndex + 1);
        }}>
        {
          formik => (
            <Form className="flex flex-col justify-center items-center">

              <div className="content-wrapper">
                <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="card-body">
                          <div className="formOuterDiv">
                            <div className="hrstyle headingcolor">
                              <h5>General Information</h5>
                            </div>
                            <div className="form1RowDiv">
                              {
                                companySessionSelection ?
                                  <FormikControl control='textarea' type='text' label='Company Name' name='orgName' disabled={true} />
                                :
                                <FormikControl control='selectNACECode' label='Company Name' options={OrgList.data.response} name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} disabled={companySessionSelection}/>
                              }
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type='text' label='Site Address' name='siteofaddress' />
                            </div>
                            <div className="form2RowDiv">
                              <FormikControl control='input' type='text' label='No. of employees' name='total' disabled={true} />
                              <FormikControl control='date' type="text" label='Date of Audit' name='dateofaudit' disabled={true} dateFormat="dd-MM-yyyy" />
                            </div>
                            <div className="form2RowDiv">
                              <FormikControl control='input' type="text" label='Mobile' name='mobile' disabled={true} />
                              <FormikControl control='input' type="text" label='Email' name='email' disabled={true} />
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type="text" label='No of Server' name='noofserver' disabled={true} />
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type="text" label='Number of WS+PC+Laptop' name='noofwspclp' disabled={true} />
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type="text" label='DataCenter  Details(If Present)' name='datacenterdetails' disabled={true} />
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type="text" label='No of Application user' name='noofappluser' disabled={true} />
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type="text" label='No of Infrastructure user(Pc/laptop etc)' name='noofinfrauser' disabled={true} />
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type='text' label='No. of Application Development and Maintenance staff *' name='noofappdev' />
                            </div>

                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type='text' label='Scope' name='scope' disabled={true} />
                            </div>
                            <div className="form1RowDiv">
                              <FormikControl control='textarea' type='text' label='Audit Objective' name='auditobject' />
                            </div>
                            <div className="hrstyle headingcolor">
                              <h5>Audit Team</h5>
                            </div>
                            <div className="form2RowDiv">
                              <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor *" options={leadauditorList}
                                onChange={(e) => {
                                  formik.setFieldValue(`teamleader`, parseInt(e.value))
                                  formik.setFieldValue(`teamleaderName`, e.label)
                                }}
                              />

                              <FormikControl control='selectNACECode' label='Technical Expert' options={technicalExpertList} name='technicalexpert'
                                onChange={(e) => {

                                  formik.setFieldValue(`technicalexpert`, e.value)
                                  formik.setFieldValue(`technicalExpertName`, e.label)
                                }}

                                values={(technicalExpertList).find(i => i.value === `technicalexpert`)} />

                            </div>

                            <div className="form2RowDiv">
                              <FormikControl control="selectNACECode" name="auditorOne" label='Auditor One' options={assitAuditorList}
                                onChange={(e) => {
                                  formik.setFieldValue(`auditorOne`, parseInt(e.value))
                                  formik.setFieldValue(`auditorOneName`, e.label)
                                }}
                              />

                              <FormikControl control="selectNACECode" name="auditorTwo" label='Auditor Two' options={assitAuditorList}
                                onChange={(e) => {
                                  formik.setFieldValue(`auditorTwo`, e.value)
                                  formik.setFieldValue(`auditorTwoName`, e.label)
                                }}
                              />

                            </div>
                            <div className="hrstyle headingcolor">
                              <h5>Audit Mandays</h5>
                            </div>


                            <div className="form2RowDiv">

                              <FormikControl control='input' type='text' label=' Stage 1 Mandays *' name='stageOneAudit' style={{ textAlign: "right" }} />
                              <FormikControl control='date' type='text' label=' Stage 1 Audit Date *' name='auditdate1' dateFormat="dd-MM-yyyy" />
                            </div>

                            <div className="form2RowDiv">
                              <FormikControl control='input' type='text' label=' Stage 2 Mandays *' name='stageTwoAudit' style={{ textAlign: "right" }} />
                              <FormikControl control='date' type='text' label='  Stage 2 Audit Date *' name='auditdate2' dateFormat="dd-MM-yyyy" />
                            </div>
                            <div className="hrstyle headingcolor">
                              <h5>Verification of the Audit Duration</h5>
                            </div>
                            <div className="row">
                              <div className="row" style={{ marginLeft: "0.5%" }}>
                                <label htmlFor="staticEmail" className="col-sm-9">Are quoted man-days adequate?
                                  <span className="required-field"> * </span>
                                </label>
                                <div className="col-sm-2 mt-3">
                                  <FormikControl control='radio' name='areqquatedmandays' options={options} />
                                </div>
                              </div>
                              <div className="row" style={{ marginLeft: "0.5%" }}>
                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in employee detail after application?
                                  <span className="required-field"> * </span>
                                </label>
                                <div className="col-sm-2 mt-3">
                                  <FormikControl control='radio' name='istherechangeemployee' options={options} />
                                </div>
                              </div>
                              <div className="row" style={{ marginLeft: "0.5%" }}>
                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in Scope?
                                  <span className="required-field"> * </span>
                                </label>
                                <div className="col-sm-2 mt-3">
                                  <FormikControl control='radio' name='istherechangescope' options={options} />
                                </div>
                              </div>
                              <div className="row" style={{ marginLeft: "0.5%" }}>
                                <label htmlFor="staticEmail" className="col-sm-9">Is there any information or Event accrued after the application date which may affect the Man-days?
                                  <span className="required-field"> * </span>
                                </label>
                                <div className="col-sm-2 mt-3">
                                  <FormikControl control='radio' name='isthereanyinforevent' options={options} />
                                </div>
                              </div>
                            </div>
                            <div className="hrstyle headingcolor">
                              <h5>  Audit Findings</h5>
                            </div>
                            <div className="fieldarray mt-3">

<FieldArray name='processAuditReportDetails'>

    {fieldArrayProps => {
        const { push, remove, form } = fieldArrayProps
        const { values } = form
        const { processAuditReportDetails } = values
        return (
            <div>
                {processAuditReportDetails.map((processDetail, index) => (
                    <div key={index}>
                        <div className="form2RowDiv">
                            <div className="formSingleElement">
                                <FormikControl control="selectNACECode" name={`processAuditReportDetails[${index}].nameofprocessid`} label='Name of the Process' options={processList.data.response}
                                    onChange={(e) => {

                                        var fillteredprocess = processAuditReportDetails.find(x => x.nameofprocessid === e.value)

                                        if (fillteredprocess) {
                                            swal({
                                                title: "Process is Already selected",
                                                icon: "warning",
                                                dangerMode: true,
                                            })
                                        } else {
                                            formik.setFieldValue(`processAuditReportDetails[${index}].nameofprocess`, e.label)
                                            formik.setFieldValue(`processAuditReportDetails[${index}].nameofprocessid`, e.value)

                                            formik.setFieldValue(`processAuditReportDetails[${index}].reference`, e.listClauses)

                                            formik.setFieldValue(`processAuditReportDetails[${index}].clausesList`, e.clausesList)


                                        }

                                    }

                                    } />

                            </div>
                            <div className="formSingleElement">
                                <label className="formSingleElementLabel">Process Owner</label>
                                <Field className="form-control" name={`processAuditReportDetails[${index}].processowner`} />
                                <div style={{ color: "red", fontSize: "15px" }}>
                                    <ErrorMessage name={`processAuditReportDetails[${index}].processowner`} />
                                </div>
                            </div>
                        </div>


                        <div className="form1RowDiv ">
                            <div className="formSingleElement">
                                <label className="formSingleElementLabel">References</label>
                                <Field className="form-control" name={`processAuditReportDetails[${index}].reference`} />
                            </div>
                        </div>

                        <div className="row mt-5" style={{ margin: "1%" }}>

                            <div className="col-sm-11">
                                <label htmlFor="staticEmail" className="col-sm-5 mt-1 mb-1">Details</label>
                                <FormikControl control='ckEditor' name={`processAuditReportDetails[${index}].details`} className="form-control" data={initialValues.processAuditReportDetails.details} />
                            </div>
                        </div>
                        <div className="row mt-3" style={{ margin: "1%" }}>
                            <label className="formSingleElementLabel">Auditor comments on</label>
                            <Field as='textarea' className="form-control" name={`processAuditReportDetails[${index}].comments`} />
                            <div style={{ color: "red" }}>
                                <ErrorMessage name={`processAuditReportDetails[${index}].comments`} />
                            </div>

                        </div>

                        <div className="fieldarray mt-3">

                            <FieldArray name={`processAuditReportDetails[${index}].clauseWiseObservation`}>

                                {fieldArrayProps => {
                                    const { push, remove, form } = fieldArrayProps
                                    const { values } = form
                                    const { clauseWiseObservation } = values
                                    return (
                                        <div>
                                            {processAuditReportDetails[index].clauseWiseObservation.map((clauseDetail, i) => (
                                                <div key={index}>
                                                    <div className="form2RowDiv">
                                                        <div className="formSingleElement">
                                                            {<FormikControl control="selectNACECode" name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`} label='Clause' options={processAuditReportDetails[index].clausesList}
                                                                onChange={(e) => {

                                                                    var fillteredprocess = processAuditReportDetails[index].clauseWiseObservation.find(x => x.clauseNo === e.value)

                                                                    if (fillteredprocess) {
                                                                        swal({
                                                                            title: "Clause is Already selected",
                                                                            icon: "warning",
                                                                            dangerMode: true,
                                                                        })
                                                                    } else {
                                                                        var fillteredprocess = processAuditReportDetails[index].clauseWiseObservation.find(x => x.clauseNo === e.value)

                                                                        if (fillteredprocess) {
                                                                            swal({
                                                                                title: "Clause is Already selected",
                                                                                icon: "warning",
                                                                                dangerMode: true,
                                                                            })
                                                                        } else {

                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`, e.value)

                                                                        }
                                                                    }

                                                                }

                                                                }
                                                            />}

                                                        </div>
                                                        <div className="formSingleElement">
                                                            <label className="formSingleElementLabel">Observation</label>
                                                            <Field as='textarea' className="form-control" name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].Observation`} />
                                                            <div style={{ color: "red" }}>
                                                                <ErrorMessage name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].Observation`} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {i > 0 && (
                                                        <div className="col-sm-4">
                                                            <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(i)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                                                        </div>
                                                    )}

                                                    <hr />

                                                </div>

                                            ))}


                                            <div className="row mt-3">
                                                <div className="col-lg-11"></div>
                                                <div className="col-lg-1 mb-3" >
                                                    <button type='button' className="btn btn-primary" onClick={() => push({
                                                        clauseNo: "",
                                                        Observation: "",

                                                    })}> + </button>
                                                </div>
                                            </div>


                                        </div>

                                    )
                                }}
                            </FieldArray>



                        </div>
                        {index > 0 && (
                            <div className="col-sm-4">
                                <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                            </div>
                        )}
                        <hr />
                    </div>

                ))}
                <div className="row mt-3">
                    <div className="col-lg-11"></div>
                    <div className="col-lg-1 mb-3" >
                        <button type='button' className="btn btn-primary" onClick={() => push({
                            nameofprocess: "",
                            nameofprocessid: "",
                            processowner: "",
                            details: "",
                            reference: "",
                            comments: "",
                            clauseWiseObservation: [{ clauseNo: "", Observation: "" }]

                        })}>Add</button>
                    </div>
                </div>


            </div>

        )
    }}
</FieldArray>
<hr />
</div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

              </div>
              {/* <button type="submit" className="btn btn-primary float-right">Next</button> */}

              <div className="card-footer">
                <div className="row">
                  <div className="col-sm-1"></div>
                 
                  <div className="col-sm-2">
                  </div>
                  <div className="col-sm-7"></div>
                  <div className="col-sm-2">
                    <button type="submit" className="btn btn-primary float-right">Next</button>
                  </div>
                </div>
              </div>
            </Form>
          )}
      </Formik>
    </div>
  );
}

export default BasicInfo1;